export default __webpack_public_path__ + "static/media/title.aa8262fa.png";